import React from 'react';
import ControlledPlayerScene from 'game/scenes/test/ControlledPlayerScene';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function ControlledPlayerScenePage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [ControlledPlayerScene],
            physics: {
              arcade: {
                debug: true,
              }
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
